import { Col, Row, TextInput } from 'ui';

export type MemberProgramsListFiltersFormValues = {
  search?: string;
};

const MemberProgramsListFilters = () => (
  <Row>
    <Col span={24}>
      <TextInput hasSearch item={{ label: 'Search', name: 'search' }} />
    </Col>
  </Row>
);

export default MemberProgramsListFilters;
